import Loadable from 'react-loadable'
import React from 'react'
import Loading from '../components/Loading/Global'

const LoadableOneNews = Loadable({
	loader  : () => import('../containers/News/OneNews'),
	loading : () => <Loading />
})

const LoadableAddNews = Loadable({
	loader  : () => import('../containers/News/ManageNews/createNews'),
	loading : () => <Loading />
})

export const newsLoadables = {
	LoadableOneNews,
	LoadableAddNews
}